import {CallJSSKey} from "@/Core/Bridge/CallJSSKey";
import TrackCommon2 from "@/Core/Track/TrackCommon2";
import ShopMgr from "@/app/(shop)/ShopMgr";
import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import RouterMgr from "@/Core/RouterMgr";
import {isLoginAccount} from "@/app/utils/auth";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {LoginGuideDialogFC} from "@/app/_dialogs/LoginGuideDialog/LoginGuideDialogFC";

export default class GameMgr {

    static paths: string[] = ['unity-game'];

    //是否是游戏页面
    static get checkGamePath() {
        const url = location.pathname;
        for (let i = 0; i < this.paths.length; i++) {
            const path = this.paths[i];
            if (url && url.includes(path)) {
                return true;
            }
        }
        return false;
    }

    static doGameType(doKey: CallJSSKey) {
        switch (doKey) {
            case CallJSSKey.OpenShop:
                TrackCommon2.iapPageClick(4)
                ShopMgr.showShopDialog();
                break;
            case CallJSSKey.OpenRedeem:
                RedeemManager.showRedeemDialog();
                break;
            case CallJSSKey.BackToMain:
                RouterMgr.back();
                RouterMgr.home();
                break;
            case CallJSSKey.TokenExpired:
                RouterMgr.login();
                break;
            case CallJSSKey.NoMoney:
                TrackCommon2.iapPageShow(1);
                if (isLoginAccount()) {
                    ShopMgr.showShopDialog();
                } else {
                    this.showLoginGuideDialogFC();
                }
                break;
        }
    }

    static showLoginGuideDialogFC() {
        SDialogManagerFC.openDialog(LoginGuideDialogFC, {
            fcKey: SDialogManagerFC.getFCKey(LoginGuideDialogFC),
            onClose: (isOk: boolean) => {

            }
        })
    }


}